
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avis-rent-a-car",
      function () {
        return require("private-next-pages/avis-rent-a-car/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avis-rent-a-car"])
      });
    }
  